import { getNewbuildingName } from './getNewbuildingName';
import { IState } from '../../store';

export const selectNewbuildingDisplayName = (state: IState) => {
  const newbuildingName = getNewbuildingName(state);

  return newbuildingName ? `ЖК «${newbuildingName}»` : null;
};
